export enum EStepState {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
  ERROR = 'error',
  SUCCESS = 'success'
}

export type TStep = {
  state?: EStepState;
  text?: string;
}

export interface IStepperProps {
  steps: TStep[];
  gap?: "small" | "large" | "auto";
}
